import type {SearchCriteriaRaw} from '../../../types';
import {createFileSizeRule} from '../fileSizeRule';
import type {FileSizeRule, TSearchTypeFileSize} from '../types';

export type RawFileSizeSearchCriteria = SearchCriteriaRaw<TSearchTypeFileSize>;

export const rawFileSizeCriteriaToRuleObject = (
	criteria: RawFileSizeSearchCriteria,
): FileSizeRule => {
	return createFileSizeRule({
		type: criteria.subtype1,
		metric: criteria.subtype2,
		fileSize: parseInt(criteria.value1),
	});
};

export default rawFileSizeCriteriaToRuleObject;
